import lazyLoading from './lazyLoading'

export default {
  name: 'Forms',
  meta: {
    expanded: false,
    title: 'menu.sales.parent',
    iconClass: 'vuestic-icon vuestic-icon-components'
  },
  children: [
    {
      name: 'salesList',
      path: '/sales/list',
      component: lazyLoading('sales/List'),
      meta: {
        title: 'menu.sales.list'
      }
    },
    {
      name: 'saleCreate',
      path: '/sales/create',
      component: lazyLoading('sales/Form'),
      meta: {
        title: 'menu.sales.create'
      },
      hidden: true
    },
    {
      name: 'saleEdit',
      path: '/sales/edit/:id',
      component: lazyLoading('sales/Form'),
      meta: {
        title: 'menu.sales.edit'
      },
      hidden: true
    },
    {
      name: 'saleRefund',
      path: '/sales/refund/:id',
      component: lazyLoading('sales/RefundForm'),
      meta: {
        title: 'menu.sales.refund'
      },
      hidden: true
    }
  ]
}




// WEBPACK FOOTER //
// ./src/store/modules/menu/sales.js